import React from 'react';

const colorClasses = {
  amber: {
    text: 'text-amber-400',
    glow: 'shadow-[0_0_20px_rgba(251,191,36,0.6)]',
    dot: 'bg-amber-500',
  },
  blue: {
    text: 'text-blue-400',
    glow: 'shadow-[0_0_20px_rgba(96,165,250,0.6)]',
    dot: 'bg-blue-500',
  },
  red: {
    text: 'text-red-400',
    glow: 'shadow-[0_0_20px_rgba(248,113,113,0.6)]',
    dot: 'bg-red-500',
  },
  green: {
    text: 'text-green-400',
    glow: 'shadow-[0_0_20px_rgba(74,222,128,0.6)]',
    dot: 'bg-green-500',
  },
};

export const LEDScoreboard = ({ teamName, score, color = 'amber', compact = false }) => {
  const colors = colorClasses[color] || colorClasses.amber;

  // Size classes based on compact prop
  const textSize = compact ? 'text-3xl' : 'text-7xl';
  const padding = compact ? 'p-2' : 'p-4';
  const glowIntensity = compact
    ? 'shadow-[0_0_10px_rgba(251,191,36,0.4)]'
    : colors.glow;

  return (
    <div className={`flex flex-col items-center ${compact ? 'gap-0' : 'gap-2'}`}>
      {/* Team Name Label - hidden in compact mode */}
      {!compact && (
        <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
          {teamName}
        </div>
      )}

      {/* LED Score Display with Ghost Segments */}
      <div className={`relative bg-black rounded-lg ${padding} shadow-[inset_0_2px_8px_rgba(0,0,0,0.8)] border border-gray-800`}>
        {/* Ghost layer - all segments visible in dim color */}
        <div
          className={`seven-segment ${textSize} font-bold text-gray-800 tabular-nums leading-none`}
          aria-hidden="true"
        >
          88
        </div>
        {/* Active layer - actual score in bright color */}
        <div
          className={`
            absolute inset-0 ${padding}
            seven-segment
            ${textSize}
            font-bold
            ${colors.text}
            ${glowIntensity}
            tabular-nums
            leading-none
          `}
        >
          {String(score).padStart(2, '0')}
        </div>
      </div>

      {/* LED Indicator Dots - hidden in compact mode */}
      {!compact && (
        <div className="flex gap-1">
          <div className={`w-2 h-2 rounded-full ${colors.dot} shadow-[0_0_8px_currentColor]`}></div>
          <div className={`w-2 h-2 rounded-full ${colors.dot} shadow-[0_0_8px_currentColor]`}></div>
          <div className={`w-2 h-2 rounded-full ${colors.dot} shadow-[0_0_8px_currentColor]`}></div>
        </div>
      )}
    </div>
  );
};
